import { useNavigate } from 'react-router-dom';
import { useVerifyOtp } from '../api/verify-otp';
import { useQueryParams } from '@/hooks/shared/use-query-params';
import { VerifyOtpForm } from '../components/verify-otp-form';

export function VerifyOtp() {
  const { redirect, authenticationId } = useQueryParams().allQueryParams;
  const navigate = useNavigate();
  const mutation = useVerifyOtp({
    mutationConfig: { onSuccess: () => (redirect ? navigate(redirect) : navigate('/')) },
  });

  return (
    <div className="space-y-4 max-w-sm mx-auto px-4">
      <h2 className="text-xl font-semibold">Verifiera dig</h2>
      <p>Vi har skickat en verifieringskod till dig. Kolla din e-post, inklusive skräppost.</p>
      <VerifyOtpForm onSubmit={(data) => mutation.mutate({ data })} defaultValues={{ authenticationId, code: '' }} />
    </div>
  );
}
